<!-- Start Navbar Area -->
<div class="navbar-area">
    <div class="evolta-nav">
        <div class="{{ styleContainer }}" style="max-width: 100%">
            <nav class="navbar navbar-expand-md navbar-light">
                <a class="navbar-brand" routerLink="/">
                    <img src="assets/img/Logo.png" alt="logo" width="200" />
                </a>

                <button
                    class="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div
                    class="collapse navbar-collapse mean-menu"
                    id="navbarSupportedContent"
                >
                    <ul class="navbar-nav">
                        <li
                            class="nav-item"
                            data-toggle="collapse"
                            data-target=".navbar-collapse.show"
                        >
                            <a
                                routerLink="/"
                                class="noWrap nav-link"
                                routerLinkActive="active"
                                [routerLinkActiveOptions]="{ exact: true }"
                            >
                                首頁
                            </a>
                        </li>

                        <li class="nav-item dropdown">
                            <a
                                href="javascript:void(0)"
                                class="nav-link dropdown-toggle"
                                data-toggle="dropdown"
                            >
                                勢能 About
                            </a>
                            <ul class="dropdown-menu">
                                <li
                                    class="nav-item"
                                    data-toggle="collapse"
                                    data-target=".navbar-collapse.show"
                                >
                                    <a
                                        routerLink="/about"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        >關於碩達</a
                                    >
                                </li>

                                <li
                                    class="nav-item"
                                    data-toggle="collapse"
                                    data-target=".navbar-collapse.show"
                                >
                                    <a
                                        routerLink="/contact"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        >聯絡我們</a
                                    >
                                </li>

                                <li
                                    class="nav-item"
                                    data-toggle="collapse"
                                    data-target=".navbar-collapse.show"
                                >
                                    <a
                                        routerLink="/downloads"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        >下載專區</a
                                    >
                                </li>
                            </ul>
                        </li>

                        <li class="nav-item dropdown">
                            <a
                                href="javascript:void(0)"
                                class="nav-link dropdown-toggle noshowsub"
                                data-toggle="dropdown"
                                id="solution-showsub-a"
                            >
                                賦能 Solution
                            </a>
                            <ul class="dropdown-menu" id="solution-submenu">
                                <li
                                    class="nav-item dropdown"
                                    style="
                                        display: flex;
                                        justify-content: space-between;
                                        align-items: center;
                                    "
                                    data-target=".navbar-collapse.show"
                                >
                                    <a
                                        routerLink="/solutions"
                                        class="nav-link solution_class"
                                        routerLinkActive="active"
                                        style="width: 100%"
                                        >解決方案</a
                                    >
                                    <a
                                        data-toggle="collapse"
                                        data-target=".solution-dropdown-submenu"
                                        (click)="
                                            showSubmenu('solution-submenu')
                                        "
                                    >
                                        <i
                                            class="fas fa-chevron-right"
                                            *ngIf="!mobile"
                                        ></i>
                                        <i
                                            class="fas"
                                            *ngIf="mobile"
                                            id="solution-fas-id"
                                            [ngClass]="{
                                                'fa-chevron-down':
                                                    solution_openfas,
                                                'fa-chevron-up':
                                                    !solution_openfas
                                            }"
                                        ></i>
                                    </a>

                                    <ul
                                        class="dropdown-menu solution-dropdown-submenu"
                                        *ngIf="!mobile"
                                        style="left: 160px; width: 170px"
                                    >
                                        <li
                                            class="nav-item"
                                            data-toggle="collapse"
                                            data-target=".solution-dropdown-submenu"
                                        >
                                            <a
                                                class="nav-link header-title"
                                                href="/solution-details?info=so1"
                                                >企業資源規劃</a
                                            >
                                        </li>
                                        <li
                                            class="nav-item"
                                            data-toggle="collapse"
                                            data-target=".solution-dropdown-submenu"
                                        >
                                            <a
                                                class="nav-link header-title"
                                                href="/solution-details?info=so2"
                                                >商業智慧與人工智慧</a
                                            >
                                        </li>
                                        <li
                                            class="nav-item"
                                            data-toggle="collapse"
                                            data-target=".solution-dropdown-submenu"
                                        >
                                            <a
                                                class="nav-link header-title"
                                                href="/solution-details?info=so3"
                                                >顧客管理與體驗</a
                                            >
                                        </li>
                                        <li
                                            class="nav-item"
                                            data-toggle="collapse"
                                            data-target=".solution-dropdown-submenu"
                                        >
                                            <a
                                                class="nav-link header-title"
                                                href="/solution-details?info=so4"
                                                >企業防疫營運不中斷戰術</a
                                            >
                                        </li>
                                        <li
                                            class="nav-item"
                                            data-toggle="collapse"
                                            data-target=".solution-dropdown-submenu"
                                        >
                                            <a
                                                class="nav-link header-title"
                                                href="/NCour"
                                                >N-Cour 永續淨零平台</a
                                            >
                                        </li>
                                    </ul>
                                </li>

                                <ul
                                    class="dropdown-menu solution-dropdown-submenu"
                                    *ngIf="mobile"
                                >
                                    <li
                                        class="nav-item"
                                        data-toggle="collapse"
                                        data-target=".navbar-collapse.show"
                                    >
                                        <a
                                            class="nav-link header-title"
                                            href="/solution-details?info=so1"
                                            >企業資源規劃</a
                                        >
                                    </li>
                                    <li
                                        class="nav-item"
                                        data-toggle="collapse"
                                        data-target=".navbar-collapse.show"
                                    >
                                        <a
                                            class="nav-link header-title"
                                            href="/solution-details?info=so2"
                                            >商業智慧與人工智慧</a
                                        >
                                    </li>
                                    <li
                                        class="nav-item"
                                        data-toggle="collapse"
                                        data-target=".navbar-collapse.show"
                                    >
                                        <a
                                            class="nav-link header-title"
                                            href="/solution-details?info=so3"
                                            >顧客管理與體驗</a
                                        >
                                    </li>
                                    <li
                                        class="nav-item"
                                        data-toggle="collapse"
                                        data-target=".navbar-collapse.show"
                                    >
                                        <a
                                            class="nav-link header-title"
                                            href="/solution-details?info=so4"
                                            >企業防疫營運不中斷戰術</a
                                        >
                                        <!-- <a class="nav-link header-title" href="/solution-details?info=資料庫與資料管理DB and DW">資料庫與資料管理</a> -->
                                        <!-- <a class="nav-link header-title" href="/coming-soon">資料庫與資料管理</a> -->
                                    </li>
                                    <li
                                        class="nav-item"
                                        data-toggle="collapse"
                                        data-target=".navbar-collapse.show"
                                    >
                                        <a
                                            class="nav-link header-title"
                                            href="/NCour"
                                            >N-Cour 永續淨零平台</a
                                        >
                                    </li>
                                </ul>
                                <!-- <button data-toggle="collapse" data-target="#demo">Collapsible</button> -->

                                <!-- <div id="demo" class="collapse">
                                    Lorem ipsum dolor text....
                                </div> -->

                                <li
                                    class="nav-item"
                                    data-toggle="collapse"
                                    data-target=".navbar-collapse.show"
                                >
                                    <!-- <a routerLink="/industrial" class="nav-link" routerLinkActive="active">產業應用</a> -->
                                    <a
                                        routerLink="/coming-soon"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        >產業應用</a
                                    >
                                </li>
                            </ul>
                        </li>

                        <li class="nav-item dropdown">
                            <a
                                href="javascript:void(0)"
                                class="nav-link dropdown-toggle noshowsub"
                                data-toggle="dropdown"
                                id="service-showsub-a"
                            >
                                動能 Service
                            </a>
                            <ul class="dropdown-menu" id="service-submenu">
                                <li
                                    class="nav-item dropdown"
                                    style="
                                        display: flex;
                                        justify-content: space-between;
                                        align-items: center;
                                    "
                                    data-target=".navbar-collapse.show"
                                >
                                    <a
                                        routerLink="/services"
                                        class="nav-link service_class"
                                        routerLinkActive="active"
                                        style="width: 100%"
                                        >服務內容</a
                                    >
                                    <a
                                        data-toggle="collapse"
                                        data-target=".service-dropdown-submenu"
                                        (click)="showSubmenu('service-submenu')"
                                    >
                                        <i
                                            class="fas fa-chevron-right"
                                            *ngIf="!mobile"
                                        ></i>
                                        <i
                                            class="fas"
                                            *ngIf="mobile"
                                            id="service-fas-id"
                                            [ngClass]="{
                                                'fa-chevron-down':
                                                    service_openfas,
                                                'fa-chevron-up':
                                                    !service_openfas
                                            }"
                                        ></i>
                                    </a>

                                    <ul
                                        class="dropdown-menu service-dropdown-submenu"
                                        *ngIf="!mobile"
                                        style="left: 160px; width: 170px"
                                    >
                                        <li
                                            class="nav-item"
                                            data-toggle="collapse"
                                            data-target=".service-dropdown-submenu"
                                        >
                                            <a
                                                class="nav-link header-title"
                                                href="/service-details?info=se1"
                                                >SAP 企業流程改造</a
                                            >
                                        </li>
                                        <li
                                            class="nav-item"
                                            data-toggle="collapse"
                                            data-target=".service-dropdown-submenu"
                                        >
                                            <a
                                                class="nav-link header-title"
                                                href="/service-details?info=se2"
                                                >軟體定義資訊中心</a
                                            >
                                        </li>
                                        <li
                                            class="nav-item"
                                            data-toggle="collapse"
                                            data-target=".service-dropdown-submenu"
                                        >
                                            <a
                                                class="nav-link header-title"
                                                href="/service-details?info=se3"
                                                >企業混合雲</a
                                            >
                                        </li>
                                        <li
                                            class="nav-item"
                                            data-toggle="collapse"
                                            data-target=".service-dropdown-submenu"
                                        >
                                            <a
                                                class="nav-link header-title"
                                                href="/service-details?info=se4"
                                                >資訊專案服務</a
                                            >
                                        </li>
                                    </ul>
                                </li>

                                <ul
                                    class="dropdown-menu service-dropdown-submenu"
                                    *ngIf="mobile"
                                >
                                    <li
                                        class="nav-item"
                                        data-toggle="collapse"
                                        data-target=".navbar-collapse.show"
                                    >
                                        <a
                                            class="nav-link header-title"
                                            href="/service-details?info=se1"
                                            >SAP 企業流程改造</a
                                        >
                                    </li>
                                    <li
                                        class="nav-item"
                                        data-toggle="collapse"
                                        data-target=".navbar-collapse.show"
                                    >
                                        <a
                                            class="nav-link header-title"
                                            href="/service-details?info=se2"
                                            >軟體定義資訊中心</a
                                        >
                                    </li>
                                    <li
                                        class="nav-item"
                                        data-toggle="collapse"
                                        data-target=".navbar-collapse.show"
                                    >
                                        <a
                                            class="nav-link header-title"
                                            href="/service-details?info=se3"
                                            >企業混合雲</a
                                        >
                                    </li>
                                    <li
                                        class="nav-item"
                                        data-toggle="collapse"
                                        data-target=".navbar-collapse.show"
                                    >
                                        <a
                                            class="nav-link header-title"
                                            href="/service-details?info=se4"
                                            >資訊專案服務</a
                                        >
                                    </li>
                                </ul>
                            </ul>
                        </li>

                        <li class="nav-item dropdown">
                            <a
                                href="javascript:void(0)"
                                class="nav-link dropdown-toggle"
                                data-toggle="dropdown"
                            >
                                知能 News
                            </a>
                            <ul class="dropdown-menu">
                                <li
                                    class="nav-item"
                                    data-toggle="collapse"
                                    data-target=".navbar-collapse.show"
                                >
                                    <a
                                        routerLink="/news"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        >最新消息</a
                                    >
                                    <!-- <a routerLink="/coming-soon" class="nav-link" routerLinkActive="active">最新消息</a> -->
                                </li>
                            </ul>
                        </li>

                        <!-- esg -->
                        <li class="nav-item dropdown">
                            <a
                                href="javascript:void(0)"
                                class="nav-link dropdown-toggle"
                                data-toggle="dropdown"
                            >
                                永續專區 ESG
                            </a>
                            <ul class="dropdown-menu">
                                <li
                                    class="nav-item"
                                    data-toggle="collapse"
                                    data-target=".navbar-collapse.show"
                                >
                                    <a
                                        routerLink="/esg/environmental"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        >E環境保護</a
                                    >
                                </li>

                                <li
                                    class="nav-item"
                                    data-toggle="collapse"
                                    data-target=".navbar-collapse.show"
                                >
                                    <a
                                        routerLink="/esg/social"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        >S社會參與</a
                                    >
                                </li>

                                <li
                                    class="nav-item"
                                    data-toggle="collapse"
                                    data-target=".navbar-collapse.show"
                                >
                                    <a
                                        routerLink="/esg/governance"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        >G公司治理</a
                                    >
                                </li>
                            </ul>
                        </li>

                        <li class="nav-item dropdown">
                            <a
                                href="javascript:void(0)"
                                class="nav-link dropdown-toggle"
                                data-toggle="dropdown"
                            >
                                儲能 Careers
                            </a>
                            <ul class="dropdown-menu">
                                <li
                                    class="nav-item"
                                    data-toggle="collapse"
                                    data-target=".navbar-collapse.show"
                                >
                                    <a
                                        routerLink="/join-us"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        >加入我們</a
                                    >
                                </li>
                            </ul>
                        </li>

                        <!-- <li class="nav-item dropdown">
                            <a href="javascript:void(0)" class="nav-link dropdown-toggle" data-toggle="dropdown">
                                Pages <i class="fas fa-chevron-down"></i>
                            </a>
                            <ul class="dropdown-menu">
                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/about" class="nav-link" routerLinkActive="active">關於碩達</a>
                                </li>

                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/features" class="nav-link" routerLinkActive="active">Features</a>
                                </li>

                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/team" class="nav-link" routerLinkActive="active">Team</a>
                                </li>

                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/pricing" class="nav-link" routerLinkActive="active">Pricing</a>
                                </li>

                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/login" class="nav-link" routerLinkActive="active">Login</a>
                                </li>

                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/register" class="nav-link" routerLinkActive="active">Signup</a>
                                </li>

                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="not-found" class="nav-link" routerLinkActive="active">404 Error</a>
                                </li>

                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/coming-soon" class="nav-link">Coming Soon</a>
                                </li>

                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/faq" class="nav-link" routerLinkActive="active">FAQ</a>
                                </li>
                            </ul>
                        </li> -->

                        <!-- <li class="nav-item" routerLinkActive="active" data-toggle="collapse" data-target=".navbar-collapse.show">
                            <a routerLink="/services" class="nav-link">服務介紹</a>
                        </li>

                        <li class="nav-item" routerLinkActive="active" data-toggle="collapse" data-target=".navbar-collapse.show">
                            <a routerLink="/blog" class="nav-link">最新消息</a>
                        </li>

                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                            <a routerLink="/join-us" class="nav-link" routerLinkActive="active">加入我們</a>
                        </li>

                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                            <a routerLink="/contact" class="nav-link" routerLinkActive="active">聯絡我們</a>
                        </li> -->
                    </ul>

                    <!-- <div class="others-options" data-toggle="collapse" data-target=".navbar-collapse.show">
                        <div class="option-item">
                            <i class="search-btn flaticon-search"></i>
                            <i class="close-btn fas fa-times"></i>

                            <div class="search-overlay search-popup">
                                <div class='search-box'>
                                    <form class="search-form">
                                        <input class="search-input" name="search" placeholder="Search" type="text">

                                        <button class="search-button" type="submit"><i class="fas fa-search"></i></button>
                                    </form>
                                </div>
                            </div>
                        </div>

                        <a routerLink="/contact" class="btn btn-primary">Free Quote</a>
                    </div> -->
                </div>
            </nav>
        </div>
    </div>
</div>
<!-- End Navbar Area -->
